module.exports = __webpack_public_path__ + "static/media/none-logo.4b0fd47e.svg";